import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Save } from "lucide-react";

export default function Settings() {
  const [cap, setCap] = useState(6);
  const [marginWed, setMarginWed] = useState(15);
  const [marginCorp, setMarginCorp] = useState(20);
  const [workStart, setWorkStart] = useState("08:00");
  const [radius, setRadius] = useState(300);
  const [msg, setMsg] = useState("");
  const [users, setUsers] = useState([]);

  async function load() {
    const [s, u] = await Promise.all([api.get("/settings"), api.get("/users")]);
    setCap(s.data.capacity);
    setMarginWed(s.data.margin.Wedding ?? 15);
    setMarginCorp(s.data.margin.Corporate ?? 20);
    setWorkStart(s.data.work_start || "08:00");
    setRadius(s.data.attendance_radius_m ?? 300);
    setUsers(u.data);
  }
  useEffect(() => { load(); }, []);

  async function save() {
    try {
      await api.post("/settings", {
        capacity: Number(cap),
        margin: { Wedding: Number(marginWed), Corporate: Number(marginCorp) },
        work_start: workStart,
        attendance_radius_m: Number(radius)
      });
      setMsg("Tersimpan");
      setTimeout(() => setMsg(""), 2000);
    } catch (ex) { setMsg(errMsg(ex)); }
  }

  async function resetPassword(u) {
    const pw = window.prompt(`Password baru untuk ${u.name} (min. 8 karakter, huruf + angka):`);
    if (!pw) return;
    try { await api.post(`/users/${u.id}/reset-password`, { new_password: pw }); setMsg(`Password ${u.name} direset`); }
    catch (ex) { setMsg(errMsg(ex)); }
  }

  async function toggleSuspend(uid) {
    await api.post(`/users/${uid}/suspend`);
    await load();
  }

  return (
    <div className="p-4 sm:p-8 space-y-6">
      <header>
        <h1 className="text-2xl sm:text-3xl font-serif-display font-bold">Pengaturan</h1>
        <p className="text-sm text-[#536263]">Capacity gate, batas margin, dan user</p>
        <div className="mt-2 h-px w-12 bg-[#B87333]"></div>
      </header>

      <div className="card-editorial p-5 space-y-4">
        <h2 className="font-serif-display text-xl font-semibold">Capacity & Margin</h2>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#B87333]">Kapasitas Event per Bulan</label>
          <input type="number" value={cap} onChange={e => setCap(e.target.value)} className="w-full mt-1 border border-[#E2DDD3] rounded-lg px-3 h-11" data-testid="setting-capacity" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs uppercase tracking-wider text-[#B87333]">Margin Min. Wedding (%)</label>
            <input type="number" value={marginWed} onChange={e => setMarginWed(e.target.value)} className="w-full mt-1 border border-[#E2DDD3] rounded-lg px-3 h-11" data-testid="setting-margin-wed" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#B87333]">Margin Min. Corporate (%)</label>
            <input type="number" value={marginCorp} onChange={e => setMarginCorp(e.target.value)} className="w-full mt-1 border border-[#E2DDD3] rounded-lg px-3 h-11" data-testid="setting-margin-corp" />
          </div>
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#B87333]">Jam Masuk (batas terlambat, WIB)</label>
          <input type="time" value={workStart} onChange={e => setWorkStart(e.target.value)} className="w-full mt-1 border border-[#E2DDD3] rounded-lg px-3 h-11" data-testid="setting-work-start" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#B87333]">Radius Absen Lapangan Default (meter)</label>
          <input type="number" min="50" value={radius} onChange={e => setRadius(e.target.value)} className="w-full mt-1 border border-[#E2DDD3] rounded-lg px-3 h-11" data-testid="setting-radius" />
          <p className="text-[11px] text-[#8A999A] mt-1">Bisa diganti per venue di Master Data.</p>
        </div>
        <button onClick={save} className="btn-primary" data-testid="setting-save"><Save size={16} />Simpan</button>
        {msg && <div className="text-sm text-emerald-700">{msg}</div>}
      </div>

      <div className="card-editorial p-5">
        <h2 className="font-serif-display text-xl font-semibold mb-3">Daftar User</h2>
        <div className="space-y-2">
          {users.map(u => (
            <div key={u.id} className="flex items-center justify-between p-3 bg-[#FAF7F2] rounded-lg">
              <div><div className="font-medium">{u.name}</div><div className="text-xs text-[#8A999A]">{u.email} · {u.role}</div></div>
              <div className="flex gap-2 flex-wrap justify-end">
              <button onClick={() => resetPassword(u)} data-testid={`reset-password-${u.id}`} className="chip bg-[#F7EFE8] text-[#B87333]">Reset Password</button>
              <button onClick={() => toggleSuspend(u.id)} data-testid={`suspend-${u.id}`}
                className={`chip ${u.suspended ? "bg-amber-100 text-amber-900" : "bg-emerald-100 text-emerald-900"}`}>
                {u.suspended ? "Suspended · klik untuk aktifkan" : "Aktif · klik untuk suspend"}
              </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
